import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IModule, ILesson } from 'interface/course';
import { fetchModules } from 'services/modules';
import { RootState } from 'redux/store';

interface IState {
  modules: IModule[];
}

const initialState: IState = {
  modules: null,
};

export const getModules = createAsyncThunk('modules/fetch', (courseHash: string, { getState }: {getState: any}) => {
  const state: RootState = getState();
  if(state.newModules.modules) return state.newModules;
  return fetchModules(courseHash);
});

const modules = createSlice({
  name: 'modules',
  initialState,
  reducers: {
    clearModules: (state) => {
      state.modules = null;
    },
    updateLessonOnModule: (state, action: {type: string, payload: { lessonId: number, data: Partial<ILesson> }}) => {
      const lessonId = action.payload.lessonId;
      const data = action.payload.data;
      const newModules = state?.modules?.map(m => ({...m, lessons: m.lessons.map(l => {
            if(l.id === lessonId) {
              return {...l, ...data}
            }
            return l;
          })
        })
        )
      state.modules = newModules;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getModules.pending, (state) => {
      state.modules = null;
    });
    builder.addCase(getModules.rejected, (state) => {
      state.modules = [];
    });
    builder.addCase(getModules.fulfilled, (state, action) => {
      state.modules = action.payload;
    });
  },
});

export const { clearModules, updateLessonOnModule } = modules.actions;
export default modules.reducer;
